import { Injectable, inject } from '@angular/core';
import { AuthService } from '../../services/deletion-email.service';
import { RouteNavigationService } from '../route-navigation.service';
import { CanActivateFn } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DeletedAccountRequestRouteGuardLogic {

  constructor(
    private authService: AuthService,
    private _routeNavigationService: RouteNavigationService
  ) {}

  async canActivate(): Promise<boolean> {
    const isScheduledForDeletion = await this.authService.isScheduledForDeletion();

    if (!isScheduledForDeletion) {
      await this._routeNavigationService.goToDeleteScheduleRequest();
      return false;
    }
    return true;
  }
}

export const DeletedAccountRequestRouteGuard: CanActivateFn = () => {
  return inject(DeletedAccountRequestRouteGuardLogic).canActivate();
};

